<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title" style="margin-top:0px">Requêtes</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="row" style="width:100%;margin-left:0px;margin-right:0px">
          <loading :active.sync="isLoading" 
              :can-cancel="false" 
              :is-full-page="true">
          </loading>
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm"
                        placeholder="Search"
                        v-model="searchQuery"
                        addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%"
                      stripe
                      :cell-class-name="tableCellClassName"
                      height="570">
              <el-table-column v-for="column in tableColumns"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :fixed="column.fixed"
              >
                <template slot-scope="scope">
                  <div v-if="scope.column.property !== 'id_requete' && scope.column.property !== 'company'">
                    <div v-if="(scope.column.property == 'id_negociateur' && scope.row[scope.column.property] == '/') || scope.column.property != 'id_negociateur'">
                      {{scope.row[scope.column.property]}}
                    </div>
                  </div>
                  <div v-if="scope.column.property === 'id_requete'">
                    <router-link class="link_table" :to="{ name: 'Requete', params: { id_requete: scope.row[scope.column.property], cid: scope.row['cid'] }}">{{scope.row[scope.column.property]}}</router-link>
                  </div>
                  <div v-if="scope.column.property === 'company'">
                    <router-link class="link_table" :to="{ name: 'Client', params: { cid: scope.row['cid'] }}">{{scope.row[scope.column.property]}}</router-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="pagination-info-p">Affichage du {{from + 1}}e au {{to}}e sur les {{total}} requêtes</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>	
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Table, TableColumn, Select, Option, Button} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(Button)
  export default {
    components: {
      PPagination,
      Loading
    },
    methods: {
      async getOrders() {
        const self = this;
        const response = await fetch(this.$api_url+'/requetes', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          //check if api return regenerated token
          if(json.code != 409) {
            self.log_api("success",'GET /requetes', '', json)
            Object.keys(json).forEach(function (key) {
              self.tableData.push(json[key])
            })
            this.isLoading = false
            return json
          }
        }
        this.isLoading = false
      },
      tableCellClassName({row, column, rowIndex, columnIndex}) {
        if(row.status == "Ouverte") {
            return "requete_ouverte"
        }
      },
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              if(row[key] !== null) {
                let rowValue = row[key].toString().toUpperCase()
                if (rowValue.includes && rowValue.includes(this.searchQuery.toUpperCase())) {
                  isIncluded = true
                }
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      },
    },
    data () {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['id_requete', 'date_created', 'date_cloture', 'company', 'phone', 'contact_princ', 'nom_type_client', 'origine', 'objet', 'status'],
        tableColumns: [
          {
            prop: 'id_requete',
            label: '#',
            fixed: true,
            minWidth: '70'
          },
          {
            prop: 'date_created',
            label: 'Date ouverture',
            fixed: false,
            minWidth: '120'
          },
          {
            prop: 'date_cloture',
            label: 'Date clôture',
            fixed: false,
            minWidth: '120'
          },
          {
            prop: 'company',
            label: 'Client',
            fixed: false,
            minWidth: '200'
          },
          {
            prop: 'contact_princ',
            label: 'Contact Principal',
            fixed: false,
            minWidth: '150'
          },
          {
            prop: 'phone',
            label: 'Téléphone',
            fixed: false,
            minWidth: '120'
          },
          {
            prop: 'nom_type_client',
            label: 'Nature',
            fixed: false,
            minWidth: '120'
          },
          {
            prop: 'origine',
            label: 'Origine',
            fixed: false,
            minWidth: '120'
          },
          {
            prop: 'objet',
            label: 'Objet',
            fixed: false,
            minWidth: '200'
          },
          {
            prop: 'status',
            label: 'Status',
            fixed: false,
            minWidth: '125'
          }
        ],
        tableData: [],
        isLoading: true,
      }
    },
    mounted() {
      this.getOrders();
    },
  }
</script>
<style lang="scss">
  .el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
  }
  .link_table {
    color: black;
    text-decoration: underline;
    font-weight: bold;
  }
  .link_table:hover {
    color: grey;
  }
  .pagination-info-p {
    font-weight: 400;
    color: #9A9A9A;
    font-size: 0.7142em;
  }
</style>